function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Clear_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.288 0C5.53 0 0 5.53 0 12.288s5.53 12.288 12.288 12.288 12.288-5.53 12.288-12.288S19.046 0 12.288 0zm5.376 15.514l-2.15 2.15-3.226-3.226-3.226 3.226-2.15-2.15 3.226-3.226-3.226-3.226 2.15-2.15 3.226 3.226 3.226-3.226 2.15 2.15-3.226 3.226 3.226 3.226z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Clear_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24.576v24.576H0V0z",
  fill: "#fff"
})));

var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xMi4yODggMEM1LjUyOTYgMCAwIDUuNTI5NiAwIDEyLjI4OEMwIDE5LjA0NjQgNS41Mjk2IDI0LjU3NiAxMi4yODggMjQuNTc2QzE5LjA0NjQgMjQuNTc2IDI0LjU3NiAxOS4wNDY0IDI0LjU3NiAxMi4yODhDMjQuNTc2IDUuNTI5NiAxOS4wNDY0IDAgMTIuMjg4IDBaTTE3LjY2NCAxNS41MTM2TDE1LjUxMzYgMTcuNjY0TDEyLjI4OCAxNC40Mzg0TDkuMDYyNCAxNy42NjRMNi45MTIgMTUuNTEzNkwxMC4xMzc2IDEyLjI4OEw2LjkxMiA5LjA2MjRMOS4wNjI0IDYuOTEyTDEyLjI4OCAxMC4xMzc2TDE1LjUxMzYgNi45MTJMMTcuNjY0IDkuMDYyNEwxNC40Mzg0IDEyLjI4OEwxNy42NjQgMTUuNTEzNloiIGZpbGw9ImJsYWNrIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cGF0aCBkPSJNMCAwSDI0LjU3NlYyNC41NzZIMFYwWiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgClear as ReactComponent };